import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import UserSettingScreen from '../components/screens/settings/UserSettingScreen';

// /settings/profile: the same account page every user category sees
export default (props) => (
  <Layout headerTitle="My Account">
    <PageContainer>
      <UserSettingScreen props={props} />
    </PageContainer>
  </Layout>
);
